import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments';
import { ServicesService } from './services.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Response } from '../../models/http-response';
import { takeUntil } from 'rxjs/operators';
import { PrismHeaders } from '../../enums';

@Injectable()
export class RejectionsService {

  selectedJob$ = this.servicesService.selectedService$;
  private rejectedAssets: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private loadingRejections: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private killRejectionsFetch$: Subject<void> = new Subject<void>();

  constructor(private servicesService: ServicesService, private http: HttpClient) {
  }

  get rejectedAssets$() {
    return this.rejectedAssets.asObservable();
  }

  get loadingRejections$() {
    return this.loadingRejections.asObservable();
  }

  killRejectionsFetch() {
    this.killRejectionsFetch$.next();
  }

  getRejectedAssets(jobId) {
    this.loadingRejections.next(true);
    this.selectedJob$
      .pipe(
        takeUntil(this.killRejectionsFetch$)
      )
      .subscribe(selectedJob => {
        const pathToFinals = `${selectedJob.fromDirectory}/finals`;
        this.killRejectionsFetch();
        const headers = new HttpHeaders()
          .set('X-Processed-Finals-Path', pathToFinals);

        this.http.get(`${environment.apiBaseUrl}/processor2-get-rejected-assets`, {headers})
          .pipe(
            takeUntil(this.killRejectionsFetch$)
          )
          .subscribe((rejectedAssets: Response) => {
            const rejectedAssetsHolder = this.rejectedAssets.value;
            rejectedAssetsHolder[jobId] = rejectedAssets.data;
            this.rejectedAssets.next(rejectedAssetsHolder);
            this.loadingRejections.next(false);
          });
      });
  }

  fetchRejectsPDF(rejections: any, serviceId: string) {

    return this.http.post(`${environment.apiBaseUrl}/processor2-get-rejections-pdf`, {rejections, serviceId}, {responseType: 'blob'});
  }
}
